import { FormattedMessage } from 'react-intl';

import { gaPush } from '@/configuration/setup/googleAnalytics';

interface CsvButtonComponentProps {
    fetchVehiclesStatusDataCsv: Function;
    isProcessing: boolean;
}

const CsvButtonComponent = ({ fetchVehiclesStatusDataCsv, isProcessing }: CsvButtonComponentProps) => (
    <button
        className="btn btn-default margin-top-auto"
        onClick={() => {
            gaPush({
                event: 'vs_button_export',
                parameters: {
                    element_name: 'CsvButtonComponent',
                    component_name: 'Button',
                    trigger: 'click',
                },
            });
            fetchVehiclesStatusDataCsv();
        }}
        disabled={isProcessing}
    >
        {isProcessing && (
            <span data-testid="csv-loading-spinner" className="rioglyph rioglyph-spinner spinning" aria-hidden="true" />
        )}
        <FormattedMessage id="intl-msg:vehicle_status.csv_button.title" />
    </button>
);

export default CsvButtonComponent;
